import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { useParam, useParamProps } from '@/composables/params';
import { ParamRadio } from '@/models/enums/WidgetEnum';
import { computed } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'RadioParam',
  props: useParamProps<ParamRadio, boolean>(),
  emits: ["update"],
  setup(__props, { emit }: { emit: ((e: 'update', value: { [key: string]: boolean }) => void), expose: any, slots: any, attrs: any }) {

const props = __props;





const { label, emitValue } = useParam(props, emit);
const { t } = useI18n();

function sendUpdate(newValue: boolean) {
  if (newValue !== value.value) {
    emitValue(newValue);
  }
}

const value = computed(
  () => props.paramValue ?? props.paramInfo.defaultValue ?? false,
);

return { __sfc: true,props, emit, label, emitValue, t, sendUpdate, value }
}

})